import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionTitleSeparatorBody,
    SectionTitleSeparatorDetails,
} from "types/api/blocks/sectionTitleSeparator";

function useSectionTitleSeparatorApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionTitleSeparators = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionTitleSeparatorDetails> => {
        return get<PathParamsWithId, undefined, SectionTitleSeparatorDetails>({
            url: "/blocks/section-title-separator/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionTitleSeparator = React.useCallback((body: SectionTitleSeparatorBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionTitleSeparatorBody, null>({
            url: "/blocks/section-title-separator",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionTitleSeparator = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-title-separator/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionTitleSeparators,
        saveSectionTitleSeparator,
        deleteSectionTitleSeparator
    };
}

export default useSectionTitleSeparatorApi;